'use strict';

function parseSseFrame(frame) {
  const lines = String(frame).split('\n');
  const dataLines = [];

  for (const raw of lines) {
    const line = raw.trim();
    if (!line || line.startsWith(':')) continue;
    if (line.startsWith('data:')) {
      dataLines.push(line.slice(5).trimStart());
    }
  }

  if (!dataLines.length) return null;

  const payload = dataLines.join('\n');
  try {
    return JSON.parse(payload);
  } catch {
    return null;
  }
}

function parseSseFrames(chunk, remainder = '') {
  const buffer = `${remainder || ''}${chunk || ''}`;
  const normalized = String(buffer).replace(/\r\n/g, '\n').replace(/\r/g, '\n');
  const events = [];
  let start = 0;

  while (true) {
    const delimiter = normalized.indexOf('\n\n', start);
    if (delimiter === -1) break;

    const frame = normalized.slice(start, delimiter).trim();
    if (frame) {
      const parsed = parseSseFrame(frame);
      if (parsed) events.push(parsed);
    }
    start = delimiter + 2;
  }

  return { events, remainder: normalized.slice(start) };
}

module.exports = { parseSseFrame, parseSseFrames };
